import React, { useCallback, useEffect, useMemo, useState, } from 'react';
import { Grid, Box, Typography } from "@mui/material";
import { styles } from "./styles";
import { AgChartsReact } from 'ag-charts-react';
import { getdevicesAddedLastYear, getdevicesByMonth } from 'apis/device';
import DashBoardDataTable from '../DataTable/DashBoardDataTable';
import moment from "moment";
import {AgCartesianSeriesTooltipRendererParams} from 'ag-charts-community';

var pageNumber = 0;
var MonthlyDevices: any = [];
var lastyeardata: any = [];
export const BarChart = () => {
    const [barChartOptions, setBarChartOptions] = useState<any>({});
    const [lastYearData, setLastYearData] = useState<any>([]);
    const [lastYearMonthlyData, setLastYearMonthlyData] = useState<any>([]);
    const [showErrorPopup, setShowErrorPopup] = useState(false);
    const [CurrchartVal, setCurrchartVal] = useState<any>("");
    const [load, setLoad] = useState<Boolean>(true);

    //console.log(CurrchartVal)


    useEffect(() => {
        localStorage.removeItem('monthSelected');
        getLastyearDevices();
        setTimeout(() => {
            getAllDevicesByMonthly()
        }, 100);
    }, []);

   

    const getLastyearDevices = async () => {
        lastyeardata = await getdevicesAddedLastYear();
        if (lastyeardata?.response?.data?.errorMessage) {
            console.log(lastyeardata.response.data.errorMessage);
            return
        }
        if (lastyeardata && lastyeardata.length > 0) {
            setLastYearData(lastyeardata);
        }
        setLastYearData(lastyeardata);
    }

    useEffect(() => {
        CreateBarChart();
        return () => {}
    }, [lastYearData]);


    const CreateBarChart = () => {
        setBarChartOptions({
            data: lastYearData,
            series: [
                {
                    type: 'column',
                    xKey: 'propName',
                    yKey: 'numValue',
                    fills: ['#4258c9'],
                    cursor: 'pointer',
                    listeners: {
                        nodeClick: (event: any) => {
                            var datum = event.datum;
                            event.datum.selected = !event.datum.selected;
                            // window.alert(datum.propDesc);
                            console.log(datum.propDesc)
                            localStorage.removeItem('monthSelected');
                            localStorage.setItem('monthSelected', datum.propDesc);
                            setCurrchartVal(datum.propDesc);
                            getAllDevicesByMonthly();
                            // setLastYearMonthlyData([]);
                        }
                    },
                    tooltip: {
                        renderer: function (params: AgCartesianSeriesTooltipRendererParams) {
                            return { content: params.datum.propName + ': ' + params.datum.numValue };
                        }
                    },
                    // formatter: (params: any) => {
                    //     // Use a different size and color for selected nodes.
                    //     if (params.datum.selected) {
                    //         return {
                    //             fill: '#888888'
                    //         };
                    //     }
                    // },
                    strokeWidth: 0
                },
            ],
            legend: {
                enabled: false
            }
        })
    }

    const getAllDevicesByMonthly = async () => {
        pageNumber = 0;
        MonthlyDevices = [];
        setLastYearMonthlyData([]);
        let data = await getdevicesByMonth();
        console.log(data);
        if (data?.response?.data?.errorMessage) {
            console.log(data.response.data.errorMessage);
            return
        }
        if (data) {
            // pageNumber = 1;
            MonthlyDevices = MonthlyDevices.concat(data.devices);
            //  console.log(MonthlyDevices);
            // if (data.hasMoreRecords) {
            //     while (true) {
            //         //pageNumber = pageNumber + 1;
            //         let data = await getdevicesByMonth();
            //         if (data) {
            //             MonthlyDevices = MonthlyDevices.concat(data.devices);
            //         }
            //         if (MonthlyDevices.length >= CommonUtil.MONTHLY_RECORD) {
            //             console.log("Total devices loaded: " + MonthlyDevices);
            //             break;
            //         }
            //         if (!data.hasMoreRecords) {
            //             break;
            //         }

            //     }

            // }
            // else { }
            MonthlyDevices.forEach((object: any) => {

                // if ('creationDate' in object && object.creationDate !== null) {
                //   const date = new Date(object.creationDate);
                //   object.creationDate = moment(date).local().format('MM/DD/YYYY h:mm:ss A');
                // }
                if ('creationDate' in object && object.creationDate !== null) {
                    const obj = object.creationDate;
                    if (obj.includes('+0000')) {
                        const date = new Date(object.creationDate);
                        // object.creationDate = new Date(object.creationDate).toLocaleString();
                        object.creationDate = moment.parseZone(date).utc().format('MM/DD/YYYY h:mm:ss A');
                    }
                    else {
                        object.creationDate = new Date(object.creationDate).toLocaleString();
                    }
                }
            });
            const sortedArray = MonthlyDevices.sort((a: any, b: any) => {
                // Convert the lastUpdateDate strings to Date objects
                const dateA = new Date(a.creationDate);
                const dateB = new Date(b.creationDate);

                // Compare the dates and return the result
                if (dateA > dateB) {
                    return -1;
                } else if (dateA < dateB) {
                    return 1;
                } else {
                    return 0;
                }
            });
            sortedArray.filter((s: any) => s.creationDate !== null);
            setLastYearMonthlyData(sortedArray);
            //console.log(lastYearMonthlyData);
        }
    }
    //console.log(lastYearMonthlyData);

    const returnBarChart = () => {
        CreateBarChart();
    };



    return (
        <Grid container>
            <Box sx={styles.boxContainer}>
                <Grid container>
                    <Grid item xs={12} sx={{ fontWeight: '600', color: '#7C7B7B' }}>
                        Total Devices Added (Last 1 Year)
                    </Grid>
                    <Grid item xs={12}>
                        {lastYearData && <AgChartsReact options={barChartOptions} />}
                    </Grid>
                </Grid>
            </Box>
            <Box sx={styles.boxContainer} style={{ marginTop: '20px' }}>
                <Grid container>
                    {lastYearMonthlyData.length > 0 ? "" :
                        <Grid item xs={12} sx={{ color: '#ccc', fontWeight: '600', textAlign: 'center' }}>
                            Select a bar on the chart above to view the detailed breakdown
                        </Grid>
                    }
                    {lastYearMonthlyData.length > 0 ? 
                     <Grid item xs={12} sx={{ height: "50vh" }}>
                        <DashBoardDataTable data={lastYearMonthlyData} />
                    </Grid> : ""}
                </Grid>
            </Box>
        </Grid>

    );
}